import * as moment from 'moment';

import { AbstractControl, ValidatorFn } from '@angular/forms';

export function billetTrafficTicketValidator(billetForm): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const billetTrafficTicketDaysFormated = control.value.split("/").reverse().join('-')
        const billetDueTimeFormated = billetForm.value.billetDueTime.split("/").reverse().join('-')

        if (control.value === '') {
            return null
        }

        const TrafficTicketDate = new Date(billetTrafficTicketDaysFormated)
        const billetDueTime = new Date(billetDueTimeFormated)

        if (TrafficTicketDate && billetDueTime) {
        const isValidBilletDiscountDays = moment(TrafficTicketDate).isAfter(billetDueTime)

        return isValidBilletDiscountDays ? null : { billetTrafficTicketValidator: true }
        }
    };
}